// Must stay in sync with the `fileSize` limits in the server pre-signed URL validations.
export const MAX_UPLOAD_FILE_SIZE_BYTES = 1024 * 1024 * 1024;

export const MAX_UPLOAD_FILE_SIZE_LABEL = '1GB';
